import { createApp } from 'vue'
import App from './App.vue'
import { Button } from 'vant';
import { Picker } from 'vant';
import { Uploader } from 'vant';
import { Image as VanImage } from 'vant';
import { Loading } from 'vant';
import { Overlay } from 'vant';
import { Toast } from 'vant';
import { Tab, Tabs } from 'vant';
import { Divider } from 'vant';
import { Dialog } from 'vant';
import { NavBar } from 'vant';

import { Form, Field, CellGroup,Cell, RadioGroup, Radio, Popup,Calendar } from 'vant';
import wx from 'jweixin-1.6.0'
// 2. 引入组件样式
import 'vant/lib/index.css';
import 'vant/es/toast/style';
import 'lib-flexible/flexible'
import 'animate.css'
import { registerWX } from './utils/methodCenter';

const app = createApp(App);
app.use(Button).use(Divider).use(NavBar).use(Dialog).use(Tab).use(Radio).use(RadioGroup).use(Cell).use(Tabs).use(VanImage).use(Toast).use(Overlay).use(Loading).use(Form).use(Field).use(CellGroup).use(Picker).use(Popup).use(Calendar).use(Uploader);



function isWeChat() { // 判断是否是微信浏览器
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
  } else {
      return false;
  }
}

function isMiniProgram(){ // 判断是否是小程序
  var ua = navigator.userAgent.toLowerCase();
  var result = ua.indexOf('miniprogram') != -1;
  console.log('is mini program:', result)
  return result
}

var pages = getQueryString("pages");
var code = getQueryString("code");
var receiptId = getQueryString("id");
var type = getQueryString("type");
var isready = 0;
var title = "单据详情";//分享标题
var desc  = "来展厅，大金和您一起燃爆618" // 分享描述默认是空
var image = "https://ex.weasley.tv/daikin_mao/share_eb0b0634e1b1aed566d729fbafb160b.png";
var shareurl = "https://ex.weasley.tv/daikin_mao/index.html";
var shareContent = ['onMenuShareTimeline', 'onMenuShareAppMessage','checkJsApi'];
var shareTitleLib = {
  second:'AIG China'
};

// 获取页面参数
function getQueryString(name)
{
    var url = window.location.search;

    var reg = new RegExp('(^|&)'+ name +'=([^&]*)(&|$)','i');

    var r = url.substr(1).match(reg);

    if (r != null) return decodeURI(r[2]); return null;
}

function register(res) {
  if(isMiniProgram()){
    shareContent = ['openLocation','getLocation','checkJsApi']
  }
  console.log('register!!!:', res)
  wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.appId, // 必填，公众号的唯一标识
      timestamp: res.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.nonceStr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名
      jsApiList: shareContent // 必填，需要使用的JS接口列表
  })

  wx.ready(() => {      //需在用户可能点击分享按钮前就先调用
      console.log('readyreadyreadyreadyreadyreadyreadyready')
        if(window.wxInit){ // 注册成功开始初始化
            window.wxInit()
        }
      isready = 1;
      if(pages){
          updateWx(shareTitleLib[pages],pages);
      }else
      {
          updateShareInfo(title,desc,shareurl,image);
      }
  });
  wx.error(() => {      //需在用户可能点击分享按钮前就先调用
      // console.log(this.$wx, 'errorerrorerrorerrorerrorerrorerrorerror')
      if(window.wxInit){ // 注册成功开始初始化
          window.wxInit()
      }
  });
}


//更新分享描述
function updateWx(shareTitle,pages){
  console.log("updateWx",shareTitle,pages,isready);
  if(isready==0)return;
  var postlocalurl = (localUrl.split("#")[0]);
  var clearlocalurl = postlocalurl.split('?')[0];
  if(pages){
      postlocalurl = clearlocalurl+'?pages='+pages;
  }
  updateShareInfo(title,shareTitle,postlocalurl,image);
}

function updateShareInfo($title,$desc,$shareurl,$image){
  wx.onMenuShareTimeline({
      title: $title, // 分享标题
      link: $shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: $image, // 分享图标
      success: () => {
          // 设置成功
      }
  })
  wx.onMenuShareAppMessage({
      title: $title, // 分享标题
      desc:$desc,// 分享描述
      link: $shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: $image, // 分享图标
      success: () => {
          // 设置成功
      }
  })
}

// 开始初始化
var localUrl = window.location.href;
if (isWeChat() || isMiniProgram()) {
  var postlocalurl = (localUrl.split("#")[0]);

  shareurl = postlocalurl;
  registerWX({ url: postlocalurl }).then((res) => {
      register(res.data);
  });
}

app.provide('myData', {
  code: code?code:'test',
  receiptId:receiptId,
  type:type,
})
app.mount('#app')